define(function (require) {
    //Identifiant unique du module (miniscule, sans caractères spéciaux)
    var MODULE_ID = "QuantaFormNumber";

    /******************************************************/
    //Dépendences du module
    var quantamodule = require("quantamodule");
    var $ = require("jquery");
    var _ = require("lodash");
    var QuantaNumber = require("QuantaNumber");
    var quantaUpdate = require("quantaUpdate");
    var i18n = require("i18n");
    /******************************************************/

    //Options par défaut
    var defaultOptions = {
        culture: i18n.locale(),
        nbDecimalAllowed: 2,
		alwaysShowDecimal: false,
		allowEmptyField : false	// si true, les champs vide ne sont pas format
    }

    var typeNumber = { ENTIER: 1, DECIMAL: 2 };

    var internalOptions = {
        cultureSettings: [
            {
                name: "fr",
                value: "fr-FR",
                settings: {
                    forbiddenCharacters: ["\\s"]
                }
            },
            {
                name: "en",
                value: "en-EN",
                settings: {
                    forbiddenCharacters: ["\\,", "\\s"]
                }
            },
            {
                name: "it",
                value: "it-IT",
                settings: {
                    forbiddenCharacters: ["\\.", "\\s"]
                }
            },
        ],
    }
    /******************************************************/

    //#region Methods
    function Methods($this) {

        function init() {
            if ($this != null && $this.length > 0) {
                $this.state.currentValue = QuantaNumber.NaN;

                $this.on("change", function () { _SetFormatted(); });

				// format à l'initialisation
				_SetFormatted();

                //On ajoute un attribut data pour marquer l'input comme étant géré par le plugin
                if ($this.attr("data-quantaformnumber") == null)
                    $this.attr("data-quantaformnumber", "true");
            }
        }

        //#region Méthodes Privées
        /**
         * Nom de fonction très important ! Le côté abstrait lui donne une sensation de puissance mais également la sensation d'être le moteur de ce plugin.
         * Elle a pour but d'Analyser (avec un grand A !) le contenu barbare d'un input de formulaire soumit à la négligence et à la vulgarité d'un utilisateur distrait.
         * Bonne chance à elle.
         */
        function _Analyse() {
            var sFormattedVal = $this.val();
            var currentCulture = _getCurrentCulture();

            if (currentCulture != null) {
                var sVal = ClearValue($this.val());

                var nVal = !QuantaNumber.isNaN(QuantaNumber.ToFloat(sVal)) ? QuantaNumber.ToFloat(sVal) : 0;
                $this.state.currentValue = nVal;

                if (!QuantaNumber.isNaN(nVal)) {
                    var settingsFormat = {
                        maximumFractionDigits: $this.options.nbDecimalAllowed,
                        minimumFractionDigits: $this.options.alwaysShowDecimal ? $this.options.nbDecimalAllowed : 0
                    };
                    sFormattedVal = QuantaNumber.ToFormat(nVal, settingsFormat);
                }
            }
            return sFormattedVal;
        }

		function _SetFormatted() {
			// si le champ est vide, on ne format pas
			if ($this.options.allowEmptyField && $this.val() == "") {
				return;
			}

            /* On sauvegarde la position du curseur pour éviter que la modification sur l'input ne nous positionne le curseur à la fin */
            var cursorPosition = {
                start: $this[0].selectionStart,
                end: $this[0].selectionEnd
            }
            $this.val(_Analyse());
            $this[0].setSelectionRange($this[0].selectionStart, $this[0].selectionEnd);
        }

        /**
         * Retourne les paramètres de la culture passée à l'initialisation du plugin
         */
        function _getCurrentCulture() {
            if ($this.options != null && $this.options.culture != null) {
                return _.find(internalOptions.cultureSettings, function (x) { return x.name.toLowerCase() == $this.options.culture.toLowerCase(); });
            }
            return null;
        }

        /**
         * Trigger quand la culture est changée par l'utilisateur !
         */
        function _onCultureChanged() {
            //On sauvegarde la valeur actuelle
            var nCurrentVal = QuantaNumber.ToFloat($this.val());

            if (!QuantaNumber.isNaN(nCurrentVal, $this.options.culture)) {
                var settingsFormat = {
                    maximumFractionDigits: $this.options.nbDecimalAllowed,
                    minimumFractionDigits: $this.options.alwaysShowDecimal ? $this.options.nbDecimalAllowed : 0
                };
                $this.val(QuantaNumber.ToFormat(nCurrentVal, settingsFormat));
            }
        }
        //#endregion

        //#region Méthodes publics
        /**
         * Supprime les caractères non numériques et le caractères interdit
         * @param {any} sVal
         */
        function ClearValue(sVal, culture) {
            if (culture == null) { culture = _getCurrentCulture(); }
			sVal = sVal.replace(new RegExp("[^0-9\\.\\,\\-(E|e)]", "g"), "");

            _.each(culture.settings.forbiddenCharacters, function (c) {
                sVal = sVal.replace(new RegExp(c, "g"), "");
            });

            return sVal;
        }

        /**
         * Renvoit les informations du QuantaNumber relatif à l'analyse de l'input
         */
        function NumberSetting() {
            return QuantaNumber.getResult($this.val(), $this.options.culture);
        }

        /**
         * Renvoit la valeur de l'input formatté
         */
        function GetFormatted() {
            return _Analyse();
        }

        /**
         * Change les options du plugins
         */
        function EditOptions(options) {
            $this.options = $.extend(true, {}, $this.options, options);
            _onCultureChanged();
        }

        /**
         * Force l'analyse et la modification sur l'input
         */
        function Reload() {
            _SetFormatted();
        }

        /**
         * Retourne la valeur numéric de l'input
         */
        function GetValue() {
            return $this.state.currentValue;
        }
        //#endregion

        //publics
        return {
            init: init,
            Reload: Reload,
            Options: EditOptions,
            Details: NumberSetting,
            GetFormatted: GetFormatted,
            GetValue: GetValue,
            ClearValue: ClearValue
        };
    };
    //#endregion



    /******************************************************/
    //#region Template Code
    $.fn[MODULE_ID] = quantamodule(MODULE_ID, defaultOptions, Methods);
    //#endregion

    //#region Fonctions Shared
    $.fn[MODULE_ID].IsInstanciated = function ($field) {
        return ($($field).attr("data-quantaformnumber") == "true");
    }

    $.fn[MODULE_ID].ClearValue = function ($field, sCulture) {
        if (sCulture == null) { sCulture = i18n.locale(); };
        var culture = _.find(internalOptions.cultureSettings, function (x) { return x.name == sCulture; });
        return Methods($field).ClearValue($field.val(), culture);
    }

    //#region Test Unitaire

    //#endregion
});
